import {
  SET_SEARCH_CONDITION,
  SET_ADDITIONAL_ITEM_FLG,
  SET_ADDITIONAL_ITEM_LIST,
  SET_QUICK_SEARCH_FLG,
  SET_SEARCH_TARGET,
  SET_AREA_CONFIG,
  SET_QUICK_SEARCH_RESULT_FLG,
  SET_COMPANY_RESULT_LIST,
  SET_NOWPAGE,
  SET_ADDITIONAL_ITEM_PAGE,
  SET_ADDITIONAL_ITEM_TARGET,
  SET_BASE_INFO_FLG,
  SET_COMPANY_INFO_FLG,
  SET_COMPANY_INFO,
  SET_BLIND_FLG,
  SET_PARENTS_LINK_BLIND_FLG,
  SET_ROOT_LINK_BLIND_FLG,
  SET_AREA_HIERARCHY_FLG,
  SET_SELECTED_COMPANY_INFO,
  SET_DOWNLOAD_INFO_FLG,
  SET_DOWNLOAD_TARGET,
  SET_DOWNLOAD_CONFIG,
  SET_DOWNLOAD_STATUS_INFO,
  SET_POLLING_ID,
  SET_HIERARCHY_KBN,
  SET_COMPANY_HIERARCHY_INFO_LIST,
  SET_AREA,
  SET_EXT_001_FLG,
  SET_EXT_002_FLG,
  SET_ADDITIONAL_COMPANY,
  SET_ADDITIONAL_JIGYOSYO,
  SET_INIT_COMPANY_STATE,
} from '../actions/CompanyAction';
import { SEARCH_TARGET } from '../../common/const';

const initState = {
  // QuickSearch入力文字
  searchCondition: null,

  // QuickSearch(詳細設定)検索条件
  quickSearchCondition: {
    // 検索対象
    search_target: SEARCH_TARGET.COMPANY_NAME,
    // 地域設定
    area_config: [],
  },
  // 取引情報リスト表示フラグ
  additionalItemFlg: false,
  // 取引情報検索結果一覧
  additionalItemList: {},
  // QuickSearch(詳細設定)表示フラグ
  quickSearchFlg: false,
  // QuickSearch(検索結果)表示フラグ
  quickSearchResultFlg: false,
  // 拠点情報表示フラグ
  baseInfoFlg: true,
  // 企業情報表示フラグ
  companyInfoFlg: true,
  // ダウンロードステータス情報
  downloadStatusInfo: {},
  // ポーリングID
  pollingId: null,
  // 企業検索結果一覧
  companyResultList: {},
  // 選択中企業情報
  selectedCompanyInfo: {
    // DUNS
    duns: null,
    // 企業コード
    kigyo_code: null,
    // 正式法人格付商号漢字
    trade_name: null,
    // 事業所コード
    office_code: null,
    id: null,
  },
  // 企業階層情報
  companyHierarchyInfoList: {},
  // 企業情報（拠点情報、企業情報）
  companyInfo: {},
  // 階層情報区分値
  hierarchyKbn: null,
  // 非公開フラグ
  blindFlg: false,
  // 国内親会社リンク非表示フラグ
  parentsLinkBlindFlg: false,
  // 国内最上位親会社リンク非表示フラグ
  rootLinkBlindFlg: false,
  // 地域階層タブ表示フラグ
  areaHierarchyFlg: false,
  // ダウンロードオプションPopup表示フラグ
  downloadConditionFlg: false,
  // ダウンロード件数超過フラグ
  downloadLimitOverFlg: false,
  // ダウンロード件数超過メッセージ
  downloadLimitOverMessage: null,
  // ダウンロードオプション
  downloadCondition: {
    // ダウンロード対象
    download_target: [],
    // ダウンロード項目
    download_config: null,
  },
  // 地域リスト
  areaList: {},
  // 現在ページ番号
  nowpage: 1,
  // 取引情報ポップアップの選択対象
  additionalItemTarget: null,
  // 取引情報ポップアップのページ番号
  additionalItemPage: 1,
  // 取引情報検索フラグ1
  ext001Flg: null,
  // 取引情報検索フラグ1
  ext002Flg: null,
  // 取引情報企業名
  additionalCompany: null,
  // 取引情報事業所名
  additionalJigyosyo: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_SEARCH_CONDITION:
      return { ...state, searchCondition: action.searchCondition };
    case SET_ADDITIONAL_ITEM_FLG:
      return { ...state, additionalItemFlg: action.additionalItemFlg };
    case SET_ADDITIONAL_ITEM_LIST:
      return { ...state, additionalItemList: action.additionalItemList };
    case SET_QUICK_SEARCH_FLG:
      return { ...state, quickSearchFlg: action.quickSearchFlg };
    case SET_SEARCH_TARGET:
      return {
        ...state,
        quickSearchCondition: {
          search_target: action.searchTarget,
          area_config: state.quickSearchCondition.area_config,
        },
      };
    case SET_AREA_CONFIG:
    {
      const idx = state.quickSearchCondition.area_config.indexOf(action.areaConfig);
      const regFlag = !(idx >= 0);
      const areaConfig = regFlag ? [action.areaConfig] : [];
      state.quickSearchCondition.area_config.forEach((area) => {
        if (regFlag) {
          areaConfig.push(area);
        } else if (action.areaConfig !== area) {
          areaConfig.push(area);
        }
      });
      return {
        ...state,
        quickSearchCondition: {
          search_target: state.quickSearchCondition.search_target,
          area_config: areaConfig,
        },
      };
    }
    case SET_QUICK_SEARCH_RESULT_FLG:
      return { ...state, quickSearchResultFlg: action.quickSearchResultFlg };
    case SET_NOWPAGE:
      return { ...state, nowpage: action.nowpage };
    case SET_ADDITIONAL_ITEM_PAGE:
      return { ...state, additionalItemPage: action.additionalItemPage };
    case SET_ADDITIONAL_ITEM_TARGET:
      return { ...state, additionalItemTarget: action.additionalItemTarget };
    case SET_COMPANY_RESULT_LIST:
      return { ...state, companyResultList: action.companyResultList };
    case SET_BASE_INFO_FLG:
      return { ...state, baseInfoFlg: action.baseInfoFlg };
    case SET_COMPANY_INFO_FLG:
      return { ...state, companyInfoFlg: action.companyInfoFlg };
    case SET_COMPANY_INFO:
      return { ...state, companyInfo: action.companyInfo };
    case SET_SELECTED_COMPANY_INFO:
      return { ...state, selectedCompanyInfo: action.selectedCompanyInfo };
    case SET_BLIND_FLG:
      return { ...state, blindFlg: action.blindFlg };
    case SET_PARENTS_LINK_BLIND_FLG:
      return { ...state, parentsLinkBlindFlg: action.parentsLinkBlindFlg };
    case SET_ROOT_LINK_BLIND_FLG:
      return { ...state, rootLinkBlindFlg: action.rootLinkBlindFlg };
    case SET_AREA_HIERARCHY_FLG:
      return { ...state, areaHierarchyFlg: action.areaHierarchyFlg };
    case SET_DOWNLOAD_INFO_FLG:
      return {
        ...state,
        downloadConditionFlg: action.downloadConditionFlg,
        downloadLimitOverFlg: action.downloadLimitOverFlg,
        downloadLimitOverMessage: action.downloadLimitOverMessage,
      };
    case SET_DOWNLOAD_TARGET:
      return {
        ...state,
        downloadCondition: {
          download_target: action.download_target,
          download_config: state.downloadCondition.download_config,
        },
      };
    case SET_DOWNLOAD_CONFIG:
      return {
        ...state,
        downloadCondition: {
          download_target: state.downloadCondition.download_target,
          download_config: action.download_config,
        },
      };
    case SET_DOWNLOAD_STATUS_INFO:
      return { ...state, downloadStatusInfo: action.downloadStatusInfo };
    case SET_POLLING_ID:
      return { ...state, pollingId: action.pollingId };
    case SET_HIERARCHY_KBN:
      return { ...state, hierarchyKbn: action.hierarchyKbn };
    case SET_COMPANY_HIERARCHY_INFO_LIST:
      return { ...state, companyHierarchyInfoList: action.companyHierarchyInfoList };
    case SET_AREA:
      return { ...state, areaList: action.areaList };
    case SET_EXT_001_FLG:
      return { ...state, ext001Flg: action.ext001Flg };
    case SET_EXT_002_FLG:
      return { ...state, ext002Flg: action.ext002Flg };
    case SET_ADDITIONAL_COMPANY:
      return { ...state, additionalCompany: action.additionalCompany };
    case SET_ADDITIONAL_JIGYOSYO:
      return { ...state, additionalJigyosyo: action.additionalJigyosyo };
    case SET_INIT_COMPANY_STATE:
      return { ...initState };
    default:
      return state;
  }
};
